import { isRetail } from './Utils';

export const Colors = isRetail() ? {
	background1: "#FFFFFF",
	background2: "#FFFFFF",
	background3: "#E6F9FE",
	background4: "#ECECEC",
	background5: "#E0F8E6",

	table1Background: "#3B3D3D",
	table1Text1: "#4A4C4C",
	table1Text2: "#4A4C4C",
	table1Text1Disabled: "#9B9B9B",
	table1Divider: "#A1AAAA",

	background2LoadingBackground: "rgba(34, 36, 36, .4)",

	text1: "#0F0F0F",
	text2: "#9EA3A3",
	text3: "#0C0D0D",
	text4: "#424645",

	label1: "#BEC4C4",
	label2: "#494C4C",

	input1Background: "#FFFFFF",
	input1Text: "#4A4A4A",
	input1Border: "#A1AAAA",
	input1ErrorBackground: "#DE4F34",

	border1: "#A1AAAA",
	border3: "#236ABF",
	border5: "#A1AAAA",
	border6: "#26853F",
} : {
	background1: "#0C0D0D",
	background2: "#3B3D3D",
	background3: "#5187E0",
	background4: "#0C0D0D",
	background5: "#E0F8E6",

	table1Background: "#3B3D3D",
	table1Text1: "#FFFFFF",
	table1Text2: "rgba(255, 255, 255, .6)",
	table1Text1Disabled: "#9B9B9B",
	table1Divider: "rgba(255, 255, 255, .4)",

	background2LoadingBackground: "rgba(34, 36, 36, .4)",

	text1: "#FAFAFA",
	text2: "#FAFAFA",
	text3: "#0C0D0D",
	text4: "#424645",
	border6: "#26853F",

	label1: "rgba(255, 255, 255, .6)",
	label2: "#494C4C",

	input1Background: "#F2F2F2",
	input1Text: "#4A4A4A",
	input1Border: "#F2F2F2",
	input1ErrorBackground: "#DE4F34",
	
	border1: "#A1AAAA",
	border3: "#A1AAAA",
	border5: "#A1AAAA",
}

export const ButtonColors = isRetail() ? {
	primaryBackground: "#5FB563",
	primaryText: "#FFFFFF",
	primaryBorder: "#448348",

	secondaryBackground: "#FFFFFF",
	secondaryText: "#4A4C4C",
	secondaryBorder: "#A1AAAA",

	tertiaryBackground: "#2FAF4E",
	tertiaryText: "#FFFFFF",
	tertiaryBorder: "#227A38",

	quaternaryBackground: "transparent",
	quaternaryText: "#4A4C4C",
	quaternaryBorder: "transparent",

	background5: "#FFFFFF",
	text5: "#42CB79",
	border5: "#42CB79",

	background6: "#FFFFFF",
	text6: "#2875C6",
	border6: "#2875C6",

	primaryDisabledBackground: "rgba(34,122,56,.6)",
	primaryDisabledText: "#FFFFFF",

	secondaryDisabledBackground: "#181A1A",
	secondaryDisabledText: "#3B3D3D",

	tertiaryDisabledBackground: "rgba(34,122,56,.6)",
	tertiaryDisabledText: "#FFFFFF",

	quaternaryDisabledBackground: "#181A1A",
	quaternaryDisabledText: "#3B3D3D",

	background5Disabled: "#181A1A",
	text5Disabled: "#3B3D3D",

	background6Disabled: "rgba(34,122,56,.6)",
	text6Disabled: "#FFFFFF",

	background7Disabled: "#FFFFFF",
	text7Disabled: "rgba(46,97,222,0.50)",
	border7Disabled: "rgba(46,97,222,0.50)",
} : {
	primaryBackground: "#848A8A",
	primaryText: "#FAFAFA",
	primaryBorder: "#848A8A",

	secondaryBackground: "#4A4C4C",
	secondaryText: "#FAFAFA",
	secondaryBorder: "#4A4C4C",

	tertiaryBackground: "#5187E0",
	tertiaryText: "#FAFAFA",
	tertiaryBorder: "#5187E0",

	quaternaryBackground: "#212424",
	quaternaryText: "#FAFAFA",
	quaternaryBorder: "#212424",

	background5: "transparent",
	text5: "#4A4C4C",
	border5: "transparent",

	background6: "#FFFFFF",
	text6: "#2875C6",
	border6: "#2875C6",

	primaryDisabledBackground: "#181A1A",
	primaryDisabledText: "#3B3D3D",

	secondaryDisabledBackground: "#181A1A",
	secondaryDisabledText: "#3B3D3D",

	tertiaryDisabledBackground: "#181A1A",
	tertiaryDisabledText: "#3B3D3D",

	quaternaryDisabledBackground: "#181A1A",
	quaternaryDisabledText: "#3B3D3D",

	background5Disabled: "#181A1A",
	text5Disabled: "#3B3D3D",

	background6Disabled: "rgba(34,122,56,.6)",
	text6Disabled: "#FFFFFF",
}

export const ModalColors = isRetail() ? {
	border: "#000",
	background: "#CDCDCD",
	text1: "#222",
	text2: "#444",
	border: "#444",
	buttonColors: ButtonColors
} : {
	border: "#000",
	background: "#CDCDCD",
	text1: "#222",
	text2: "#444",
	border: "#444",
	buttonColors: ButtonColors
}